import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/inventory'
import Component from 'components/OverstockInventory/SelectItemInventory'

export default createListModalContainer({ actions })(Component)
